import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { RouteGaurdService } from '../../common/services/route-gaurd.service';
import { ArchivePageViewerComponent } from './archive-page-viewer/archive-page-viewer.component';
import { PageViewerComponent } from './page-viewer/page-viewer.component';
import { TableOfContentComponent } from './shared-components/table-of-content/table-of-content.component';
import { ShowAllinOnePageComponent } from './show-allin-one-page/show-allin-one-page.component';


const pageRouteMatcher = (url: UrlSegment[]) => {
  if ((url.length >= 1 && url[0].path.match(/^[0-9]+$/gm)) ||
    (url.length >= 1 && url[0].path.split("-").length > 2 && url[0].path.split("-")[0].match(/^[0-9]+$/gm) && url[0].path.split("-")[1].match(/^[0-9]+$/gm) && (url[0].path.split("-")[2].match(/^[0-9]+$/gm) || url[0].path.split("-")[2].toUpperCase().match(/^S[0-9]+$/gm)))) {
     return {
      consumed: url
    };
  }
  return null;
}

const showAllRouteMatcher = (url: UrlSegment[]) => {
  if ((url.length == 2 && url[0].path.match(/^[0-9]+$/gm) && url[1].path == "showallinonepage")
    || (url.length == 3 && ((url[0].path.match(/^[0-9]+$/gm) && url[1].path == "showallinonepage" && url[2].path.includes("-")) || (url[0].path.match(/^[0-9]+$/gm) && url[1].path.match(/^[0-9]+$/gm) && url[2].path == "showallinonepage")))
    || (url.length == 4 && (url[0].path.match(/^[0-9]+$/gm) && url[1].path.match(/^[0-9]+$/gm) && url[2].path == "showallinonepage") && url[3].path.includes("-"))) {
    return {
      consumed: url
    };
  }
  return null;
}

const showAllPlusRouteMatcher = (url: UrlSegment[]) => {
  if ((url.length == 2 && url[0].path.match(/^[0-9]+$/gm) && url[1].path == "showallinonepageplus")
    || (url.length == 3 && ((url[0].path.match(/^[0-9]+$/gm) && url[1].path == "showallinonepageplus" && url[2].path.includes("-")) || (url[0].path.match(/^[0-9]+$/gm) && url[1].path.match(/^[0-9]+$/gm) && url[2].path == "showallinonepageplus")))
    || (url.length == 4 && (url[0].path.match(/^[0-9]+$/gm) && url[1].path.match(/^[0-9]+$/gm) && url[2].path == "showallinonepageplus") && url[3].path.includes("-"))) {
    return {
      consumed: url
    };
  }
  return null;
}

const routes: Routes = [
  {
    canActivate: [RouteGaurdService],
    path: 'archiveContent/:/:',
    component: ArchivePageViewerComponent,
    data: {
      title: 'Archive Content'
    }
  },
  {
    canActivate: [RouteGaurdService],
    path: ':/tableOfContent',
    component: TableOfContentComponent,
    data: {
      title: 'General'
    }
  },
  {
    matcher: showAllRouteMatcher,
    canActivate: [RouteGaurdService],
    component: ShowAllinOnePageComponent,
    data: {
      title: 'General'
    }
  },
  {
    matcher: showAllPlusRouteMatcher,
    canActivate: [RouteGaurdService],
    component: ShowAllinOnePageComponent,
    data: {
      title: 'General'
    }
  },
  {
    // path: ":pageId",
    matcher: pageRouteMatcher,
    canActivate: [RouteGaurdService],
    component: PageViewerComponent,
    data: {
      title: 'General'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicationRoutingModule { }
